import {sendDiscoveryEventBeacon} from "@/lib/discoveryEventBeacon";

/**
 * Extracts the program slug from a nav href, whether relative or absolute.
 * Not anchored to the start of the path — the app runs under a basePath
 * (`NEXT_PUBLIC_DISCOVERY_BASE_PATH`, e.g. "/discover"), so a real href looks
 * like "/discover/program/aops-online", not "/program/aops-online".
 *
 * Resolved against a placeholder base so relative hrefs go through `URL`
 * too, not just absolute ones — `.pathname` then strips any query string or
 * fragment either way (e.g. a link carrying `?utm_source=...`).
 */
export function programSlugFromHref(href: string): string | null {
	let pathname: string;
	try {
		pathname = new URL(href, "http://localhost").pathname;
	} catch {
		return null;
	}
	return /\/program\/([^/]+)\/?$/.exec(pathname)?.[1] ?? null;
}

/**
 * Header nav links are plain `<a href>` (full-page navigations), so this
 * uses `sendDiscoveryEventBeacon` — a fire-and-forget Server Action fetch
 * would get aborted by the navigation before it could complete.
 */
export function trackIfProgramLink(href: string) {
	const programSlug = programSlugFromHref(href);
	if (programSlug) {
		sendDiscoveryEventBeacon("program_selected", {
			program_slug: programSlug,
			source: "header_nav",
		});
	}
}
